export default "__VITE_ASSET__ab463989__"